import { Backdrop, Box, CircularProgress } from '@mui/material';
import { isEmpty } from 'lodash-es';
import type { FC } from 'react';
import { useFullscreenLoader } from 'store/features/UI';
import { FullscreenLoaderTextStyle } from './FullscreenLoader.styles';

const FullscreenLoader: FC = () => {
  const { isFullscreenLoading, fullscreenLoadingText } = useFullscreenLoader();

  return (
    <Backdrop
      sx={{
        color: (theme) => theme.palette.customColors.white50,
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      open={isFullscreenLoading}
    >
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress
          color="inherit"
          data-test={isFullscreenLoading ? 'fullscreen-loading' : 'fullscreen-loading-hidden'}
        />

        {!isEmpty(fullscreenLoadingText) && (
          <Box sx={FullscreenLoaderTextStyle}>{fullscreenLoadingText}</Box>
        )}
      </Box>
    </Backdrop>
  );
};

export default FullscreenLoader;
